import React from 'react';
import { useIntl } from 'react-intl';
import LinkCell from '@/components/table/LinkCell';
import { typedValue } from '../../helper';

const FormObjectTableCell = ({ field, item }) => {
  const intl = useIntl();
  return (
    <LinkCell
      className={`aridhia-form-object-table-cell-${field.type}`}
      value={typedValue(item[field.name], intl, field)}
    />
  );
};

export default FormObjectTableCell;
